module.exports = __webpack_public_path__ + "static/Circle-d009f4008dd7e5a986d999c34881999c.png";